import analyticsLoggerImpl from '@autopass-web/mochi-analytics';

class Analytics {
  init = (key) => analyticsLoggerImpl.init(key);

  setUserId = (id) => analyticsLoggerImpl.setUserId(id);

  log = (name, properties) => analyticsLoggerImpl.log(name, properties);

  promotion_pageView = () => this.log('優惠列表頁-主頁_pageview');
  promotion_tab_onClick = ({ name }) =>
    this.log('優惠列表頁-優惠切換按鈕_點擊', { name });
  promotion_banner_onClick = (props) =>
    this.log('優惠列表頁-推薦優惠_點擊', props);
  promotion_item_onClick = (props) => this.log('優惠列表頁-優惠_點擊', props);
  promotion_group_pageView = ({ id }) =>
    this.log('推薦優惠頁_pageview', { id });
  promotion_detail_pageView = ({ id, name }) =>
    this.log('優惠明細頁_pageview', { id, name });
}

export default Analytics;
